<template>
  <div>
    <FormSelect
      v-show="!loadingError && taskTypeHasAvailableFees"
      :options="despatchStockLookup"
      :value="parseInt(value || 0)"
      @input="valueUpdated($event)"
      :placeholder="placeholder"
      :field="field"
      :note="note"
      :loading="loading"
    />
    <span class="text-danger" v-if="loadingError">{{loadingError}}</span>
    <FormStaticLabel v-if="!loadingError && !taskTypeHasAvailableFees">No fees available for task type</FormStaticLabel>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'TaskTypeDespatchStockSelect',
  model: {
    event: 'input'
  },
  props: {
    value: [Number, String],
    taskTypeId: Number,
    placeholder: String,
    field: String,
    note: String,
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      taskTypeList: []
    }
  },
  computed: {
    currentTaskType() {
      return this.taskTypeList.find(taskType => taskType.id == this.taskTypeId)
    },
    isNoFeeStockItemAllowed() {
      return this.currentTaskType ? this.currentTaskType.isNoFeeStockItemAllowed : false
    },
    taskTypeHasAvailableFees() {
      return this.despatchStockLookup.length > 0
    },
    despatchStockLookup() {
      var noneItem = { value: 0, name: 'None'}

      if(!this.currentTaskType)
        return [noneItem]

      var outputList = []

      if(this.isNoFeeStockItemAllowed)
        outputList.push(noneItem)

      outputList = _.concat(outputList, this.currentTaskType.availableFeeStocks.map(stock => {
        return {
          value: stock.id,
          name: `${stock.code} | ${stock.name}`
        }
      }))

      return outputList
    }
  },
  watch: {
    taskTypeId: function() {
      // If the fee stock item isn't in the list, clear it
      if(!this.despatchStockLookup.some(lookup => lookup.value == this.value))
        this.$emit('input', null)
    }
  },
  mounted() {
    this.loading = true

    this.$apiService.tasksService.getTaskTypeList()
    .then(response => {
      this.taskTypeList = response.data

      // If the fee stock item isn't in the list, clear it
      if(!this.despatchStockLookup.some(lookup => lookup.value == this.value))
        this.$emit('input', null)

    })
    .catch(err => {
      this.loadingError = 'Error accessing data'
    })
    .finally(() => {
      this.loading = false
    })
  },
  methods: {
    valueUpdated(value) {
      this.$emit('input', value ? parseInt(value) : null)
    }
  }
}
</script>